import { UseMutateAsyncFunction, useMutation } from "@tanstack/react-query";
import { DELETE_SHIPMENT_INVOICE_PHOTO } from "@/constants/Query";
import { apiRequest } from "@/utils/apiRequest";
import { AxiosResponse } from "axios";
import { IDeleteShipmentInvoiceRequest } from "@/types/apiResponse.types";
import { toast } from "react-toastify";
import { TDeleteShipmentInvoice } from "@/types/apiParam.types";
import { useTranslations } from "next-intl";

export const useDeleteShipmentInvoicePhotoRequest = (): UseMutateAsyncFunction<
  AxiosResponse<IDeleteShipmentInvoiceRequest>,
  Error,
  TDeleteShipmentInvoice,
  unknown
> => {
  const t = useTranslations();
  const { mutateAsync: deleteInvoice } = useMutation({
    mutationFn: (data: TDeleteShipmentInvoice) =>
      apiRequest(DELETE_SHIPMENT_INVOICE_PHOTO, "delete", data),
    onSuccess: () => {
      toast.success(t("invoice_removed_successfully"), {
        position: "top-center",
      });
    },
    onError: () => {
      toast.error("Error occured", { position: "top-center" });
    },
  });
  return deleteInvoice;
};
